import { render } from "./StockMovements.vue?vue&type=template&id=f38cc2d4&scoped=true"
import script from "./StockMovements.vue?vue&type=script&lang=js"
export * from "./StockMovements.vue?vue&type=script&lang=js"

import "./StockMovements.vue?vue&type=style&index=0&id=f38cc2d4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38cc2d4"]])

export default __exports__